/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const full_url = window.location.href;
  
  // Ajout au panier
  document.addEventListener('theme:cart:added', function() {
    setTimeout(getCartContents, 100);
  });
  
  // Mise à jour du panier
  document.addEventListener('theme:cart:update', function() {
    setTimeout(getCartContents, 100);
  });
  
  // Fermeture du panier
  document.addEventListener('theme:cart:close', function() {
    getCartContents();
  });

  // Bulles panier (toutes)
  function updateCartBubble(count) {
    document.querySelectorAll('[data-cart-bubble], .cart-bubble').forEach(function(el) {
      el.textContent = count;
      el.classList.toggle('cart-bubble--hidden', count < 1);
    });
  }
  
  // Récupérer le contenu du panier
  function getCartContents() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {

        updateCartBubble(cart.item_count);
        
        cart.items.forEach(item => {
          
          // Page Cart
          if ( full_url.includes("https://www.leonorgreyl.com/cart") ){
            var cartItem = document.querySelector('.cart__items .cart__item[product-id="'+ item.product_id +'"] .cart__item__quantity');
            // Moins de 5 quantités
            if (item.quantity < 5){
              if ( cartItem && cartItem.classList.contains("full-quantity") ){
                cartItem.classList.remove("full-quantity");
              }
            // 5 quantités
            } else if ( item.quantity == 5 ) {
              if ( cartItem && !cartItem.classList.contains('full-quantity')) {
                cartItem.classList.add("full-quantity");
              }
            // Plus de 5 quantités
            } else if (item.quantity >= 6) {
              if ( cartItem ) {
                cartItem.querySelector(".cart__item__quantity-minus").click();
              }
            }
            
          // Page Produit
          } else if ( full_url.includes("/products/") ){
            var productInput = document.querySelector(".product__block.product__form__wrapper input[name=product-id]");
            if ( productInput && item.product_id == productInput.getAttribute("value") ){
              if (item.quantity < 5){
                const remainingAllowed = 5 - item.quantity;
                document.querySelectorAll('.select-popout__item').forEach(option => {
                  const quantityLink = option.querySelector('.select-popout__option');
                  if (quantityLink) {
                    const value = parseInt(quantityLink.getAttribute('data-value'));
                    option.style.display = value > remainingAllowed ? 'none' : '';
                  }
                });
              } else {
                var formWrapper = document.querySelector(".product__block.product__form__wrapper");
                var submitBtn = document.querySelector(".product__block.product__form__wrapper .product__submit__add");
                var qtySelector = document.querySelector(".selector-wrapper--qty-form>.selector-wrapper--qty");
                if (formWrapper) formWrapper.classList.add("no-btn");
                if (submitBtn) submitBtn.setAttribute("disabled", "");
                if (qtySelector) qtySelector.remove();
              }
            }
          }

          // Toutes les pages
          var productItem = document.querySelector(".product-grid-item[card-product-id='"+ item.product_id +"']");
          if (productItem && item.quantity >= 5) {
            var button = productItem.querySelector(".product-upsell__btn");
            if (button) button.setAttribute("disabled", "");
            var quickBuy = productItem.querySelector(".product-grid-item__quick-buy");
            if (quickBuy) quickBuy.remove();
          }
          var upsellItem = document.querySelector(".product-upsell__holder[card-product-id='"+ item.product_id +"']");
          if (upsellItem && item.quantity >= 5) {
            var upsellBtn = upsellItem.querySelector(".product-upsell__btn");
            if (upsellBtn) upsellBtn.remove();
          }
          
        });
      });
  }
  
  getCartContents();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();